import { FeatureWallDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useTeamChartFeature = (companyId: number) => {
  const { data: featureData } = useQuery(FeatureWallDocument, {
    variables: {
      companyId: companyId,
      featureName: 'dev_people_chart',
    },
  })

  const feature = featureData?.features?.features?.[0]
  const hasFeature = feature?.enabled || false

  return {
    teamChartFeatureEnabled: hasFeature,
    teamChartFeature: feature,
  }
}
